import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {  FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { NgToastService } from 'ng-angular-popup';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DrawingService } from '@/app/services/shared/drawing.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { DocumentService } from '@/app/services/shared/document.service';
import { ProgressService } from '@/app/services/shared/progress.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {  MatDatepickerModule } from '@angular/material/datepicker';
import {  MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
@Component({
  selector: 'app-dialog-content-example-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatIconModule
  ],
  templateUrl: './dialog-content-example-dialog.component.html',
  styleUrl: './dialog-content-example-dialog.component.css',
})
export class DialogContentExampleDialogComponent implements OnInit {
  isEditing = false; // Track if we are in edit mode
  newFileName = ''; // Store the new filename

  documentForm: any = FormGroup;
  selectedFiles: File[] = [];
  isDragging = false;
  files: any[] = [];
  form: any;
  document_type: any;
  project_id: any;
  showSpinner = true;

  searchText: string = '';
  allSets: any;
  selectedSet: string | null = null; // Selected set


  documentLength = 0;
  documentName = '';
  stage3Progress :any;
  isExpanded = false;

  constructor(

    private documentService: DocumentService,
    private projectsService: ProjectsService,
    private toast: NgToastService,
    private drawingService: DrawingService,
    private getProjectIdService: GetProjectIdService,
    private progressService : ProgressService,
      private getFileIconService: GetFileIconUtilityService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }
 
  // Handle selection change if needed
  onSelectionChange(event: any): void {
    this.selectedSet = event.value;
  }

  toggleAdvancedOptions() {
    this.isExpanded = !this.isExpanded;
  }
  ngOnInit(): void {

    this.progressService.progress3$.subscribe(value => {
      this.stage3Progress = value;
    });

    this.project_id = this.getProjectIdService.getProjectId();
    this.document_type = this.data?.documentType;
    
    // Load the filename from local storage when the component initializes
    const savedFileName = localStorage.getItem('filename');
    if (savedFileName) {
      this.file.name = savedFileName; // Set filename from local storage
    }

    this.documentService.documentLength$.subscribe(length => {
      this.documentLength = length;
    });

    this.documentService.documentName$.subscribe(name => {
      this.documentName = name;
    });

  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    if (event.dataTransfer?.files) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  lastUploadedFileName = ''; // Declare a variable to store the last uploaded file name

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFiles(input.files);
    }
  }

  handleFiles(fileList: FileList) {
    for (let i = 0; i < fileList.length; i++) {
      this.files = [...this.files, fileList[i]]; // Update reference for change detection
    }

    // Save the last uploaded file name
    if (fileList.length > 0) {
      this.lastUploadedFileName = fileList[fileList.length - 1].name;
    }
  }

  uploadFile() {
    if (this.files.length > 0) {
      const dataToSubmit = new FormData();

      dataToSubmit.append('document_title', this.lastUploadedFileName);

      dataToSubmit.append(
        'project_id',
        // '1'
        this.project_id
      );

      this.files.forEach((uploadedFile) => {
        dataToSubmit.append('document_documents[]', uploadedFile);
      });

      dataToSubmit.append('document_status', 'pending');

      dataToSubmit.append('document_user_doc_no', 'test');
      dataToSubmit.append('document_type', this.document_type);
      dataToSubmit.append('file_type', String(this.document_type));
      dataToSubmit.append('type', String(this.document_type));
      this.projectsService.addDesignDocument(dataToSubmit).subscribe({
        next: () => {
          const message = `${this.document_type} Added Successfully`;
          const capitalizedMessage = message.charAt(0).toUpperCase() + message.slice(1);
      
          this.toast.success(
            capitalizedMessage,
            'SUCCESS',
            4000
          );
          if(this.documentLength == 0){
            const progress = this.stage3Progress + (100/7)
            this.progressService.updateProgress3(progress);  
          }
          this.drawingService.notifyDrawingUpdate();
        },
        error: (error: any) => {
          console.error('Login failed:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    }
  }
  
  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  file = {
    name: 'example.txt', // Sample filename
  };

  startEditing(index: number) {
    this.newFileName = this.file.name; // Set input value to current filename
    this.isEditing = true; // Switch to edit mode

    console.log('The pass index is:', index);
    if (index >= 0 && index < this.files.length) {
      console.log('the pass file element is:', this.files[index]);
    } else {
      console.log('Index out of bounds');
    }
  }

  saveFileName() {
    this.file.name = this.newFileName; // Update filename
    localStorage.setItem('filename', this.file.name); // Save to local storage
    this.isEditing = false; // Exit edit mode
  }

  cancelEditing() {
    this.isEditing = false; // Exit edit mode without saving
  }
  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
}
